export const menuStyle = {
  'display': 'block',
  '& > li': {
    '& > div:first-child': {
      display: 'none',
    },
  },
};
